module.exports = __webpack_public_path__ + "img/cmda_logo.422a021f.png";